
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useAiAssistantSettings } from '@/hooks/use-ai-assistant-settings';

export function useEngagementTracking(
  currentSessionId: string | null,
  currentTopic: string | null
) {
  const { user } = useAuth();
  const { userMetadata, updateUserMetadata } = useAiAssistantSettings();
  
  // Track user engagement statistics in metadata
  useEffect(() => {
    // Early return if required values are null/undefined
    if (!currentSessionId || !user?.id) {
      return;
    }
    
    const trackEngagement = async () => {
      try {
        // Update session view count
        const sessionKey = `session_${currentSessionId}_views`;
        const currentViews = userMetadata?.[sessionKey] || 0;
        
        await updateUserMetadata({
          last_viewed_topic: currentTopic,
          [sessionKey]: currentViews + 1,
        });
      } catch (error) {
        console.error('Error tracking engagement:', error);
      }
    };
    
    trackEngagement();
  }, [currentSessionId, user?.id, currentTopic, userMetadata, updateUserMetadata]);
}
